export class Departamento {
    codigo: number;
    nombredep1: string;
    nombredep2: string;
    activo: boolean;
    departamento_cods: any[];
    nodepartamento_cods: any[];
}